export default __webpack_public_path__ + "static/media/icon-cadastro.0c9d4a22.svg";